import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { CodeClub } from 'app/shared/models/class/club/club';
import { ClubRessource } from 'app/shared/models/class/resource/resource';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  action: string;
  resource: any;
  clubCode: string;
}

type switchOptions = {
  [key: string]: any
};
@Component({
  selector: 'app-open-dialog-add-edit-resource',
  templateUrl: './open-dialog-add-edit-resource.component.html',
  styleUrls: ['./open-dialog-add-edit-resource.component.scss']
})
export class OpenDialogAddEditResourceComponent implements OnInit {

  resourceForm: UntypedFormGroup;
  title: string;
  confirm = false;

  typeOfRessource = false;
  color: ThemePalette = 'primary';
  userConnected: InfosUser;
  clubCode: string;

  today = new Date();
  clubs: CodeClub[];
  btnConfirm: string;
  text: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditResourceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private clubService: ClubService,
    private authService: AuthService,
    private uiService: UiService,
    private route: ActivatedRoute

  ) {
  }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  onSubmit(): void {

    const resource = new ClubRessource(this.f.clubCode.value.code, this.f.firstName.value, this.f.lastName.value, this.f.pseudo.value);

    switch (this.data.action) {
      case 'add':
        this.clubService.addResource(resource).subscribe({
          next: () => {
            this.dialogRef.close({ data: resource.clubCode });
          },
          error: error => this.uiService.showSnackbar(error.error)
        });

        break;
      case 'edit':
        resource.clubRessourceKey = this.data.resource.clubRessourceKey;
        this.clubService.updateResource(resource).subscribe({
          next: () => {
            this.dialogRef.close({ data: resource.clubCode });
          },
          error: error => this.uiService.showSnackbar(error.error)
        });

        break;
      default:
        break;
    }

  }

  closeDialog(): void {
    this.dialogRef.close({ data: this.data.resource?.clubCode });
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter une ressource',
        confirm: 'Ajouter',
        text: 'Ressource ajoutée'
      },
      edit: {
        title: 'Éditer une ressource',
        confirm: 'Mettre à jour',
        text: 'Ressource mise à jour',
      },
    };
    return label[this.data.action][type];
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();

    const clubCode = {
      admin: this.route.snapshot.queryParams.clubCode,
      club: this.userConnected.club_code
    };

    this.clubCode = clubCode[this.userConnected.role];
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');

    this.getClubs();
  }

  private getClubs(): void {
    const queryClubCode = this.route.snapshot.queryParams.clubCode;
    this.clubService.getClubs().subscribe({
      next: clubs => {
        this.clubs = clubs;
        const club = clubs.find(c => c.code === this.clubCode);
        this.f.clubCode.setValue(club);
        this.f.clubCode.disable();
      }
    });
  }

  get f() {
    return this.resourceForm.controls;
  }

  private initForm(): void {

    this.resourceForm = this.formBuilder.group({
      clubCode: ['', Validators.required],
      firstName: [this.data.resource ? this.data.resource.clubRessourceFirstName : '', Validators.required],
      lastName: [this.data.resource ? this.data.resource.clubRessourceLastName : '', Validators.required],
      pseudo: [this.data.resource ? this.data.resource.clubRessourcePseudo : '', Validators.required]
    });
  }


}
